var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppBar',{on:{"clickIconBar":_vm.handleIconBar}}),_c('AppMenu',{staticClass:"elevation-3",attrs:{"mini":_vm.miniMenu,"clipped":""},model:{value:(_vm.activeMenu),callback:function ($$v) {_vm.activeMenu=$$v},expression:"activeMenu"}}),_c('v-content',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }